import styled from 'styled-components'
import dsTheme from '../../constants/design-system/theme.json'
import { progressiveBreakpoints } from '../../constants/theme'

const { colors, typography } = dsTheme

export const Wrapper = styled.div`
  @media ${progressiveBreakpoints.desktop} {
    display: flex;
  }
`

export const Column = styled.div`
  @media ${progressiveBreakpoints.desktop} {
    margin-right: 2rem;
    width: 80%;
  }
`

export const IntercomWrapper = styled.div`
  background-color: ${colors['Brand/PaleBlue']};
  padding: 1rem;
  margin-top: 0.5rem;
  img {
    width: 3.5rem;
  }
  @media ${progressiveBreakpoints.desktop} {
    display: flex;
    align-items: flex-start;
    img {
      margin: 0 0.5rem;
    }
  }
`

export const TextWrapper = styled.div`
  padding: 1rem 1rem 1.5rem;
  border-bottom: 1px solid ${colors['UI/LightGrey']};
  @media ${progressiveBreakpoints.desktop} {
    border-bottom: none;
    margin-top: 1rem;
  }
`

export const ButtonWrapper = styled.div`
  margin: 1rem 0 0;
  @media ${progressiveBreakpoints.desktop} {
    width: 70%;
  }
`

export const StyledH3 = styled.h3`
  ${typography['Kollektif/SmallEmphasis']};
  margin: 1.5rem 0 0.5rem 0;
  @media ${progressiveBreakpoints.desktop} {
    ${typography['Kollektif/MediumEmphasis']};
    width: 95%;
    margin-bottom: ${(props) => props.bottomMargin && '1rem'};
  }
`

export const Text = styled.p`
  ${typography['Kollektif/Small']};
  margin-bottom: 1rem;
  @media ${progressiveBreakpoints.desktop} {
    ${typography['Kollektif/Medium']};
  }
`

export const SmallText = styled.p`
  ${typography['Kollektif/Small']};
  // TODO: next line fixes a design system bug we can't yet merge
  font-size: 0.875rem;
  margin-top: ${(props) => props.topMargin && '1rem'};
  text-align: ${(props) => props.textAlign && 'center'};
  @media ${progressiveBreakpoints.desktop} {
    ${typography['Kollektif/Small']};
  }
`

export const SmallEmphasisText = styled.p`
  ${typography['Kollektif/ExtraSmallEmphasis']};
  // TODO: next line fixes a design system bug we can't yet merge
  font-weight: bold;
  margin-bottom: 1rem;
  @media ${progressiveBreakpoints.desktop} {
    ${typography['Kollektif/SmallEmphasis']};
  }
`
